import { addFromUrl, addParamsToUrl } from '@zapier/url-utils';

import encodeErrorBundle from '../utils/encodeErrorBundle';
import { GET_HELP_PATH } from '../constants';

export const buildGetHelpPath = ({
  zap,
  error,
  ...passed
}: {
  zap?: number | string;
  error?: Error | string;
  [key: string]: any;
} = {}) => {
  const params: {
    [key: string]: string | undefined;
  } = {
    ...passed,
  };

  if (error) {
    params.error = typeof error === 'string' ? error : encodeErrorBundle(error);
  }

  const path = addParamsToUrl(
    zap ? `${GET_HELP_PATH}/zap/${zap}` : GET_HELP_PATH,
    params,
    true
  );

  return typeof window === 'undefined'
    ? path
    : addFromUrl(path, window.location.href);
};

export default buildGetHelpPath;
